module.exports = __webpack_public_path__ + "img/copy-share.7ade6bf3.svg";